<template>
	<div style="user-select: none">
		<myHeader @oneStepFun="oneStepFun" @oneMaterialFun="oneMaterialFun"></myHeader>
		<oneSteptoStation @onRootFun="onRootFun" @leaveStation="leaveStation" v-if="isStat" :class="[{ stat: isStat }]"></oneSteptoStation>
		<oneMaterial @materialFun="materialFun" @leaveStation="leaveStation" v-if="isMaterial" :class="[{ stat: isMaterial }]"></oneMaterial>
		<div :class="['ds',{hideStat:!isStat}]">
			<sideCon></sideCon>
			<div class="conect" style="position: relative;">
				<router-view></router-view>
				<div class="temp_outer">
					<div class="temp_inner">
						<div></div>
					</div>
				</div>
			</div>
		</div>
		<div id="loadGit" class="app_tips_art" @click="loadFun">
			<div class="tips_art_inner"><img class="imgs" v-if="appTips.isLoad" src="/static/image/load.gif" /></div>
		</div>
		<div :class="['prev_iframe',{fullwin:isfull}]" v-show="root" @click="onComplete">
			<div v-show="param.type == 1" class="pc_pfe">
				<div class="inner"><span class="closeRapidSite"></span></div>
				<iframe :src="root" id="ifrm" width="100%" height="100%" frameborder="0" scrolling="auto" style=""></iframe>
			</div>
			<div v-show="param.type != 1" class="m_pfe">
				<div class="inner"><span class="closeRapidSite"></span></div>
				<div :class="['containerp',{is_piew:isPhone}]">
					<div class="conect_inner">
						<iframe :src="root" id="ifrm" width="100%" height="100%" frameborder="0" scrolling="auto" style=""></iframe></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	import myHeader from '../components/m/header.vue'
	import oneSteptoStation from '../components/oneSteptoStation.vue'
	import sideCon from '../components/m/sideCon.vue'
	import oneMaterial from '../components/oneMaterial.vue';
	//import t2 from '@/components/t2/layout.vue'

	export default {
		components: {
			myHeader,
			sideCon,
			oneMaterial,
			oneSteptoStation
		},
		data() {
			return {
				appTips: {
					isShow: false,
					isLoad: true,
					appMsg: "请填写完整信息！"
				},
				// id: this.$route.params.id,
				// tm: this.$route.params.tm,
				param: {
					type: this.$route.query.type
				},
				root: "",
				isStat: false,
				isMaterial: false,
				isPhone: this.$route.name != 't1',
				isTop: false,
				isfull: false,
				style: {
					position: "fixed",
					left: "10px",
					top: "80px"
				}
			}
		},
		created() {
			Vue.prototype.$appTips = this.appTips;
			if(location.href.indexOf("allsite") == -1) {
				// localStorage.clear();
			}
		},
		mounted: function() {
			var ts = this;
			var iframe = document.getElementById("ifrm");
			if(iframe) {
				iframe.onload = function() {
					$("#loadGit").hide();
				};

			}
		},
		methods: {
			oneMaterialFun() {
				var ts = this;
				ts.isMaterial = !ts.isMaterial; // debugger
				ts.isStat = false;
				if(ts.isMaterial) {
					$('html').css({
						overflow: 'hidden',
						paddingRight: '6px'
					});
				} else {
					setTimeout(function() {
						$('html').css({
							overflow: 'auto',
							paddingRight: '0'
						});
					}, 500);
				}
			},
			oneStepFun() {
				var ts = this;
				ts.isStat = !ts.isStat;
				ts.isMaterial = false;
				if(ts.isStat) {
					$('html').css({
						overflow: 'hidden',
						paddingRight: "6px"
					})
					ts.root = "";
				} else {
					setTimeout(function() {
						$('html').css({
							overflow: 'auto',
							paddingRight: "0"
						})
					}, 500);
					ts.root = "";
				}
			},
			materialFun(flag) {
				this.isMaterial = flag;
				setTimeout(function() {
					$('html').css({
						overflow: 'auto',
						paddingRight: '0'
					});
				}, 500);
			},
			onComplete() {
				//console.log("onComplete");
				this.isfull = !this.isfull;
			},
			loadFun() {
				setTimeout(function() {
					$("#loadGit").hide();
				}, 2000);
			},
			leaveStation() {
				this.root = "";
			},
			onRootFun(url) {
				var ts = this;
				//if(ts.param.type == 1) {
				$("#loadGit").show();
				ts.root = url;
				//}
			}
		}
	}
</script>
<style lang="scss">
	@import "../style/scss/templateEdit";
	.el-dialog__header {
		background-color: #ddd;
	}
	
	.side_inner {
		position: fixed;
		margin-left: 20px;
		.funOuterPanel {
			width: 360px;
			border-radius: 5px;
			background: #fff;
			box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_module {
			background-position: -959px -899px
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_skin {
			background-position: -959px -949px
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_setup {
			background-position: -959px -1017px
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_opt {
			background-position: -959px -1085px
		}
		.funPanelEntryBtn:hover {
			background-color: #0D83ED;
		}
		.funPanelEntryBtn_module:hover {
			width: 100px
		}
		.funPanelEntryBtn_skin:hover {
			width: 100px
		}
		.funPanelEntryBtn_setup:hover {
			width: 100px
		}
		.funPanelEntryBtn_opt:hover {
			width: 130px
		}
		.funPanelEntryBtn:last-child {
			margin-bottom: 0
		}
		.funPanelEntryBtnText {
			display: none;
			height: 54px;
			margin-left: -8px;
			line-height: 54px;
			color: #fff;
			font-size: 15px;
			font-family: "微软雅黑";
			white-space: nowrap;
			vertical-align: top
		}
		.funPanelEntryBtn_module:hover .funPanelEntryBtnText {
			display: inline-block
		}
		.funPanelEntryBtn_skin:hover .funPanelEntryBtnText {
			display: inline-block
		}
		.funPanelEntryBtn_setup:hover .funPanelEntryBtnText {
			display: inline-block
		}
		.funPanelEntryBtn_opt:hover .funPanelEntryBtnText {
			display: inline-block
		}
		.entryBtnsList_hover .funPanelEntryBtn {
			background-color: #5874d8
		}
		.entryBtnsList_hover .funPanelEntryBtn .funPanelEntryBtnText {
			display: inline-block
		}
		.entryBtnsList_hover .funPanelEntryBtn_module {
			width: 100px
		}
		.entryBtnsList_hover .funPanelEntryBtn_skin {
			width: 100px
		}
		.entryBtnsList_hover .funPanelEntryBtn_setup {
			width: 100px
		}
		.entryBtnsList_hover .funPanelEntryBtn_opt {
			width: 130px
		}
		.entryBtnsList_hover .funPanelEntryBtn .funPanelEntryBtnIcon_module {
			background-position: -959px -899px
		}
		.entryBtnsList_hover .funPanelEntryBtn .funPanelEntryBtnIcon_skin {
			background-position: -959px -949px
		}
		.entryBtnsList_hover .funPanelEntryBtn .funPanelEntryBtnIcon_setup {
			background-position: -959px -1017px
		}
		.entryBtnsList_hover .funPanelEntryBtn .funPanelEntryBtnIcon_opt {
			background-position: -959px -1085px
		}
		.funPanelEntryBtn {
			height: 54px;
			width: 54px;
			border-radius: 54px;
			overflow: hidden;
			margin-bottom: 15px;
			background: #fafafa;
			line-height: 0;
			cursor: pointer;
			box-shadow: 2px 3px 7px 0 rgba(0, 0, 0, 0.2);
			transition: background-color, width .2s;
		}
		.funPanelEntryBtnText {
			display: none;
			height: 54px;
			margin-left: -8px;
			line-height: 54px;
			color: #fff;
			font-size: 15px;
			font-family: "微软雅黑";
			white-space: nowrap;
			vertical-align: top;
		}
		.funPanelEntryBtnIcon_module {
			background-position: 2px -2px;
		}
		.funPanelEntryBtnIcon_skin {
			background-position: -39px -2px;
		}
		.funPanelEntryBtnIcon_setup {
			background-position: -79px -2px;
		}
		.funPanelEntryBtnIcon {
			display: inline-block;
			width: 54px;
			height: 54px;
			background-image: url('/static/image/iconIndex.png');
			background-repeat: no-repeat;
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_opt {
			background-position: -286px -2px;
		}
		.funPanelEntryBtnIcon_opt {
			background-position: -118px -2px;
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_module {
			background-position: -167px -2px;
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_skin {
			background-position: -207px -2px;
		}
		.funPanelEntryBtn:hover .funPanelEntryBtnIcon_setup {
			background-position: -248px -2px;
		}
	}
	
	.side_inner {
		z-index: 20000000;
	}
	
	.pc_pfe {
		height: 100%;
	}
	
	.imgM {
		background-color: #0D83ED;
	}
	
	.app_tips_art {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1000000;
		display: none;
		img {
			padding: 20px 0;
			height: 80px;
			width: 80px;
		}
		.tips_art_inner {
			position: absolute;
			top: 40%;
			margin-top: -40px;
			left: 50%;
			margin-left: -100px;
			padding: 0 20px;
			color: #fff;
			font-weight: 700;
			background-color: rgba(0, 0, 0, 0.8);
			min-height: 40px;
			line-height: 40px;
			min-width: 50px;
			border-radius: 8px;
		}
	}
	
	.prev_iframe {
		position: absolute;
		z-index: 999999;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: #fff;
		-webkit-transition: all .4s ease .2s;
		transform: translateY(300px);
		.inner {
			height: 30px;
			position: relative;
		}
		box-shadow: -3px -3px 10px 0px rgba(0,
		0,
		0,
		0.25);
	}
	
	.top {
		z-index: 1009481 !important;
	}
	
	.fullwin {
		transform: translateY(0);
	}
	
	.closeRapidSite {
		display: block;
		position: absolute;
		top: 11px;
		left: 50%;
		cursor: pointer;
		margin-left: -5px;
		z-index: 2;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-bottom: 10px solid #a4a4a4;
	}
	
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/page/templateEdit.vue